"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonParse = jsonParse;
exports.renderLink = renderLink;
exports.camelCaseProps = camelCaseProps;

var _preact = _interopRequireWildcard(require("preact"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function jsonParse(prop) {
  try {
    return JSON.parse(prop);
  } catch (e) {
    return prop;
  }
}

function renderLink(link, content, className, renderFunction, id) {
  var target = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '_self';
  return renderFunction ? renderFunction(content, link, className) : (0, _preact.h)("a", {
    id: id,
    className: className,
    href: link,
    target: target
  }, content);
}

function camelCaseProps(props) {
  var newProps = {};
  Object.keys(props).forEach(function (key) {
    return newProps[key] = jsonParse(props[key.toLowerCase()] || props[key]);
  });
  return newProps;
}